// =========================================================================
//  Network
// =========================================================================

export type SuiNetwork = "DEVNET" | "TESTNET" | "LOCAL" | "MAINNET";
